import { BaseDrawOption } from '@/modules/ta/legacy/widget/models/drawoptions/BaseDrawOption';

export class GoalDrawOption extends BaseDrawOption {}
